import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  standalone: false,
  selector: 'fdb-document',
  templateUrl: './document.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./document.component.scss']
})
export class DocumentComponent {

  constructor() { }

}
